import React from 'react';
import Modal from './Modal';
import CloseIcon from '../../icons/CloseIcon';
var NeedHelpModal = function (_a) {
    var isHelpOpen = _a.isHelpOpen, onClose = _a.onClose, externalReference = _a.externalReference, type = _a.type, isPolicyActive = _a.isPolicyActive;
    var renderContactInfo = function () {
        if (isPolicyActive) {
            if (type === 'coterie') {
                return (React.createElement("div", { className: "flex flex-col gap-2 py-3 text-sm" },
                    React.createElement("p", { className: "font-bold text-slate-900" }, "For Policy related questions, contact Coterie on:"),
                    React.createElement("div", { className: "flex items-center gap-2" },
                        React.createElement("a", { href: "mailto:support@coterieinsurance.com", className: "text-sm text-primary hover:underline font-medium" }, "support@coterieinsurance.com"),
                        React.createElement("span", null, " | "),
                        React.createElement("p", { className: "font-bold text-slate-900" }, "+1 (855) 566-1011")),
                    React.createElement("p", { className: "text-sm" }, "Monday\u2013Friday | 8am\u20138pm ET"),
                    React.createElement("a", { href: "https://coterieinsurance.com/support/", target: "_blank", rel: "noreferrer", className: "!text-blue-600 !underline" }, "Support Center")));
            }
            if (type === 'amtrust') {
                return (React.createElement("div", { className: "flex flex-col gap-2 py-3" },
                    React.createElement("p", { className: "text-sm" },
                        "Please call",
                        ' ',
                        React.createElement("span", { className: "font-bold text-slate-900 capitalize" }, "Amtrust"),
                        ' ',
                        "at",
                        ' ',
                        React.createElement("span", { className: "font-bold text-slate-900" }, "+1 (844) 603-0066")),
                    React.createElement("div", { className: "text-sm flex gap-2" },
                        React.createElement("p", null, " Email : "),
                        React.createElement("a", { href: "mailto:AmTrustPSC@amtrustgroup.com", className: "font-medium hover:underline underline-offset-4 transition-colors" }, "AmTrustPSC@amtrustgroup.com")),
                    React.createElement("p", { className: "text-sm text-slate-500" }, "Hours: Mon-Fri, 8:00 AM - 5:00PM ET")));
            }
        }
        if (type === 'cna') {
            return (React.createElement("div", { className: "flex flex-col gap-2 py-3" },
                React.createElement("div", null,
                    React.createElement("p", { className: "text-base font-semibold text-slate-900" }, "CNA Small Business Service Center")),
                React.createElement("p", { className: "text-sm text-slate-500 italic leading-relaxed" }, "For all questions relating to Service Center business including certificate requests:"),
                React.createElement("div", { className: "flex flex-wrap items-center gap-x-2 gap-y-1 text-sm" },
                    React.createElement("a", { href: "mailto:sbsc@cna.com", className: "font-medium text-violet-700 hover:text-violet-900 hover:underline underline-offset-4 transition-colors" }, "sbsc@cna.com"),
                    React.createElement("span", { className: "text-slate-300" }, "|"),
                    React.createElement("span", { className: "font-bold text-slate-900" }, "+1 (877) 724-2669"),
                    React.createElement("span", { className: "text-slate-600" }, ", option 3")),
                React.createElement("div", { className: "flex flex-col gap-2" },
                    React.createElement("p", { className: "text-sm text-slate-500" },
                        React.createElement("span", { className: "font-semibold text-slate-700" }, "For Certificates:"),
                        ' ',
                        "option 3, then option 1"),
                    React.createElement("p", { className: "text-sm font-medium text-slate-500" }, "Hours: 8am - 8pm EST daily"))));
        }
        if (type === 'hiscox') {
            return (React.createElement("div", { className: "space-y-2" },
                React.createElement("p", { className: "text-sm" },
                    "Please call",
                    ' ',
                    React.createElement("span", { className: "font-bold text-slate-900 capitalize" }, "Hiscox"),
                    ' ',
                    "at",
                    ' ',
                    React.createElement("span", { className: "font-bold text-slate-900" }, "+1 (866) 739-0727")),
                React.createElement("p", { className: "text-sm text-slate-500" }, "Weekdays 7am\u201410pm EST; Weekends 8am\u20145pm EST")));
        }
        return (React.createElement("div", { className: "space-y-2" },
            React.createElement("p", { className: "text-sm" },
                React.createElement("span", { className: "font-bold" }, "Contact WTW at:"),
                " ",
                React.createElement("br", null),
                React.createElement("a", { href: "mailto:Kwant.Insurance@wtwco.com", className: "text-primary hover:text-blue-700 hover:underline font-medium" }, "Kwant.Insurance@wtwco.com"),
                ' ',
                "| ",
                React.createElement("span", { className: "font-bold text-slate-900" }, "+1 (713) 754-5200")),
            React.createElement("p", { className: "text-sm text-slate-500" }, "(Mon-Fri, 8:00 AM - 5:00 PM CT)")));
    };
    return (React.createElement(Modal, { isOpen: isHelpOpen, onClose: onClose },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("h2", { className: "text-2xl font-bold text-[#1E293B]" }, "Need Help?"),
                React.createElement("button", { onClick: onClose, className: "p-1 rounded-full border-2 border-[#94A3B8] text-[#94A3B8] hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors" },
                    React.createElement(CloseIcon, { size: 20 }))),
            React.createElement("div", { className: "mt-4 space-y-6 text-[#475569]" },
                !isPolicyActive && (React.createElement("ul", { className: "space-y-2\n             list-disc pl-5 marker:text-slate-900" },
                    React.createElement("li", { className: "text-sm" }, "Need higher limits?"),
                    React.createElement("li", { className: "text-sm" }, "Need a Primary & Non-Contributory endorsement?"),
                    React.createElement("li", { className: "text-sm" }, "Have any additional quote questions?"))),
                React.createElement("div", { className: "pt-1" },
                    renderContactInfo(),
                    React.createElement("div", { className: "mt-2 text-sm leading-relaxed text-slate-500" },
                        React.createElement("p", null,
                            "Refer to your ",
                            isPolicyActive ? 'Policy' : 'Quote',
                            " ID:",
                            ' ',
                            React.createElement("span", { className: "font-bold text-slate-900" }, externalReference || '---'))))))));
};
export default NeedHelpModal;
